import styled from 'styled-components';

const ContainerHeader = styled.div`
  width: 310px;

  & .header {
    color: var(--text-text02);
    font-weight: 900;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 12px;
  }

  @media (min-width: 1280px) {
    width: 1128px;
    margin: 0 auto;

    & .header {
      margin-bottom: 24px;
    }
  }
`;

const ContainerContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  @media (min-width: 1280px) {
    padding-left: 0px;
    width: 1128px;
    margin: 0 auto;
  }

  /* @media (min-width: 1280px) {
    width: 1191px;
    margin: 0px 5px;
    margin-left: auto;
    margin-right: auto;
  } */

  overflow-x: hidden;
`;

const ProceduresCardContainerV2 = styled.div<{ isNotRegister?: boolean }>`
  background: #ffffff;
  width: 100%;
  min-height: ${(props) => (props.isNotRegister ? '160px' : '100%')};
  border-radius: ${(props) =>
    props.isNotRegister ? '8px 8px 0px 0px' : '8px'};
  align-items: center;

  @media (min-width: 1280px) {
    min-height: 88px;
    display: flex;
    margin-left: 0px;
  }

  //   @media (min-width: 992px) {
  //     width: 100%;
  //     height: 216px;
  //   }
`;

const ProceduresSelectContainer = styled.button`
  display: flex;
  width: 270px;
  height: 45px;
  padding: 0px 0px 43px 0px;
  margin: 4px 12px 10px 0px;
  border-radius: 5px;
`;

const FooterCard = styled.footer`
  width: 100%;
  height: 40px;
  display: flex;
  padding: 8px;
  border-radius: 0px 0px 8px 8px;
  background-color: #d5e5f0;
  margin-top: 0px;
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: start;
  column-gap: 4px;
  text-align: center;

  @media (max-width: 1280px) {
    height: 76px;
  }

  @media (max-width: 640px) {
    height: 76px;
  }
`;

const ProcedureTooltipContainer = styled.div`
  margin: 6px 0px 0px 0px;
`;

const ProcedureTitle = styled.div`
  font-size: 14px;
  font-weight: 900;
  color: #161d1f;
  display: flex;
  align-items: center;
  height: 30px;
  width: 241px;

  @media (min-width: 1280px) {
    /* min-width: 280px; */
    // margin-right: 32px;
  }
`;

const ProcedureCardHeader = styled.div`
  display: flex;
  padding: 16px 12px;
  align-items: center;

  @media (min-width: 1280px) {
    padding: 24px 0px 24px 24px;
    width: 344px;
    min-width: 344px;
  }

  & img {
    margin-right: 12px;
  }
`;

const ProcedureCardBody = styled.div`
  display: flex;
  margin: 12px;

  @media (min-width: 1280px) {
    align-items: center;
    margin: 24px 16px 24px 24px;
    width: 264px;
    min-width: 264px;
  }

  // & img {
  //   margin-right: 12px;
  // }
`;

const ProceduresCardDates = styled.div`
  padding: 2px 12px 2px 12px;
  font-size: 12px;
  min-width: 220px;

  @media (min-width: 1280px) {
    padding: 24px 0px 24px 14px;
    width: 350px;
  }

  & div {
    font-weight: 400;
  }
  & div > b {
    font-weight: 700;
  }
`;

const ProceduresCardButtonContainer = styled.div`
  padding: 12px;
  margin: 0 10px 0 0;
`;

const DetailButton = styled.button`
  display: flex;
  align-items: center;
  background: #ffffff;
  padding: 14px 0px 12px 0px;
  width: 100%;
  color: #5b36f2;
  border-radius: 4px;
  border: 1px solid #5b36f2;
  align-items: center;
  justify-content: center;
  height: 40px;

  b {
    font-weight: 700;
    font-size: 14px;
  }

  &:hover {
    background-color: #e2dffd;
  }

  &:focus {
    background-color: #c6c0fc;
    border-color: #c6c0fc;
    outline: 0;
  }

  img {
    // width: 14px;
    // height: 14px;
    // lineheight: 20px;
  }

  @media (min-width: 1280px) {
    // margin-left: 127px;
    width: max-content;
    height: 40px;
    padding: 0px 10px 0px 16px;
  }
`;

const ProcedureStatus = styled.div`
  margin-right: 8px;
  width: 84px;
  height: 20px;
  color: #ffffff;
  text-align: center;
  border-radius: 4px;
`;

const ProcedureStep = styled.div`
  margin-right: 95px;
`;

const IconCertification = styled.img`
  //   margin: 28px 12px 28px 24px;
  width: 32px;
  height: 32px;
`;

const CardRectangle = styled.div`
  content: '';
  width: 100%;
  height: 1px;
  background-color: #d5e5f0;

  @media (min-width: 1280px) {
    width: 1px;
    height: 40px;
  }
`;

const TextSeparator = styled.img`
  margin-right: 8px;
`;

const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 48px;

  @media (min-width: 1280px) {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;

const ChevronContainer = styled.button`
  margin: 0px 20px;
  color: #8090bb;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  padding: 2px 0px;

  @media (min-width: 768px) {
    padding: 2px 6px;
  }

  &:hover {
    background-color: #e2dffd;
    color: #5b36f2;
  }
  &:active,
  &:focus {
    background-color: #c6c0fc;
    border-color: #c6c0fc;
    outline: 0;
  }

  &.disable {
    color: #8090bb;
  }
  &.disable:hover {
    background-color: transparent;
    cursor: not-allowed;
  }
`;

const PaginationItems = styled.button`
  align-items: center;
  text-align: center;
  margin: 0px 6px;
  color: #4f6168;
  width: 24px;
  height: 24px;
  background-color: #ffffff;
  border-radius: 12px;
  line-height: 16px;

  @media (min-width: 768px) {
    margin: 0px 10px;
  }

  &:hover {
    background-color: #e2dffd;
    color: #4f6168;
  }

  &:active,
  &:focus {
    background-color: #c6c0fc;
    outline: 0;
  }

  &.active {
    color: #ffffff;
    background-color: #5b36f2;
  }

  &.active:hover {
    color: #ffffff;
    background-color: #745ef6;
  }
  &.active:active,
  &.active:focus {
    background-color: #4318cd;
    outline: 0;
  }
`;

const WrapperGoToButton = styled.button.attrs((props: any) => ({
  padding: props.padding,
  buttonType: props.buttonType
}))`
  display: inline-flex;
  align-items: center;
  padding: ${(props) => props.padding};
  border-radius: 4px;
  -webkit-transition: background 400ms ease-in-out;
  transition: background 400ms ease-in-out;
  > Label {
    font-size: 14px;
    font-weight: 700;
    color: var(--button-${(props) => props.buttonType}-main);
  }
  > cc-icon {
    color: var(--button-${(props) => props.buttonType}-main);
  }
  :hover {
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background-color: var(--button-${(props) => props.buttonType}-hover);
  }
  :focus {
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background: var(--button-${(props) => props.buttonType}-focus);
    outline: 0;
  }
  :active {
    -webkit-transition: background 0ms ease-in-out;
    transition: background 0ms ease-in-out;
    background-color: var(--button-${(props) => props.buttonType}-focus);
  }
`;

const ContainerGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (min-width: 1280px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export {
  ContainerHeader,
  ContainerContent,
  FooterCard,
  ProceduresSelectContainer,
  DetailButton,
  IconCertification,
  ProcedureStatus,
  ProcedureTitle,
  CardRectangle,
  TextSeparator,
  ProcedureStep,
  ProcedureCardHeader,
  ProcedureCardBody,
  ProceduresCardDates,
  ProceduresCardButtonContainer,
  WrapperGoToButton,
  ProcedureTooltipContainer,
  PaginationContainer,
  ChevronContainer,
  PaginationItems,
  ContainerGrid,
  ProceduresCardContainerV2
};
